import axios from "axios";

export const getFacturasPendientes = async () => {
    return axios.get('api/FacturasPendientes/GetFacturasPendientes')
}
